import styled, { css } from "styled-components";

export const StyledPageLayout = styled.div`
  padding-left: 0;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 88px);
  justify-content: space-between;
  transition:
    padding-left 320ms cubic-bezier(0.2, 0.8, 0.2, 1),
    padding-right 250ms ease;
  margin-top: 88px;

  @media (min-width: 1024px) {
    --crypto-sportsbook-desktop-header-offset: 88px;
    padding-left: ${({ $isSidebarOpen }) => ($isSidebarOpen ? "240px" : "55px")};
    padding-right: 0;
  }

  @media (max-width: 1023px) {
    min-height: ${({ $isGamePlayerPage }) =>
      $isGamePlayerPage ? "100dvh" : "calc(100dvh - 58px)"};
    margin-top: ${({ $isGamePlayerPage }) => ($isGamePlayerPage ? "0" : "58px")};
  }

  .background-overlay {
    position: fixed;
    z-index: 99;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: rgba(9, 22, 29, 0.76);
  }
`;

export const ContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0px auto;
  width: 100%;
  max-width: 1170px;
  padding: ${({ $isGamePlayerPage, $isTabletScreen }) => {
    if ($isGamePlayerPage) return $isTabletScreen ? "0" : "24px 24px 48px";
    return $isTabletScreen ? "16px 16px 24px" : "24px 24px 48px";
  }};
  background: var(--crypto-bg);

  ${({ $isGamePlayerPage }) =>
    $isGamePlayerPage &&
    css`
      body.crypto-game-player-theater & {
        max-width: min(1840px, 100%);
        padding: 8px 16px 22px;
      }
    `}

  @media (max-width: 1023px) {
    max-width: ${({ $isGamePlayerPage }) => ($isGamePlayerPage ? "100%" : "1170px")};
    background: ${({ $isGamePlayerPage }) => ($isGamePlayerPage ? "#000" : "var(--crypto-bg)")};
  }
`;

export const SportsContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-width: 0;
  min-height: 0;
  height: calc(100dvh - 88px);
  padding: 0;
  overflow: hidden;
  background: var(--crypto-bg-deep);

  @media (max-width: 1023px) {
    height: auto;
    min-height: calc(100dvh - 58px);
    overflow: visible;
  }
`;
